import user1 from '@/assets/icon/persona/user1.svg';
import user2 from '@/assets/icon/persona/user2.svg';
import user3 from '@/assets/icon/persona/user3.svg';

const workspaceData = [
  {
    workspaceId: 1,
    workspaceName: 'minionz',
    persona: user1,
  },
  {
    workspaceId: 2,
    workspaceName: 'sabuzaks',
    persona: user2,
  },
  {
    workspaceId: 3,
    workspaceName: 'dopamines',
    persona: user3,
  },
];

export default workspaceData;
